import {
    Project,
    ProjectDatasets,
    ProjectModels,
    Wizard,
    WizardDataset,
    Process,
} from '@/screens'

import VisualizationSubview from '@/screens/Project/Process/views/VisualizationSubview.vue'
import ConformanceSubview from '@/screens/Project/Process/views/ConformanceSubview.vue'
import TracesSubview from '@/screens/Project/Process/views/TracesSubview.vue'
import BoosterSubview from '@/screens/Project/Process/views/BoosterSubview.vue'
import DashboardsSubview from '@/screens/Project/Process/views/DashboardsSubview.vue'
import SettingsSubview from '@/screens/Project/Process/views/SettingsSubview.vue'
import AnalysisToolsSubview from '@/screens/Project/Process/views/AnalysisToolsSubview.vue'

export default [
    {
        path: '',
        name: 'ProjectDetail',
        component: Project,
        redirect: { name: 'ProjectDatasets' },
        children: [
            {
                path: 'datasets',
                name: 'ProjectDatasets',
                component: ProjectDatasets,
            },
            {
                path: 'models',
                name: 'ProjectModels',
                component: ProjectModels,
            },
            {
                path: 'wizard',
                name: 'Wizard',
                component: Wizard,
                redirect: { name: 'WizardDataset' },
                children: [
                    {
                        path: 'dataset',
                        name: 'WizardDataset',
                        component: WizardDataset,
                    },
                ],
            },
        ],
    },
    {
        path: 'discoveries/:processId',
        name: 'Process',
        component: Process,
        redirect: { name: 'ProcessVariants' },
        children: [
            {
                path: 'process',
                name: 'ProcessVariants',
                component: VisualizationSubview,
                props: { forcedTab: 'MODEL', hideTabs: true },
                meta: { footer: true, contextDrawer: true },
            },
            {
                path: 'rework',
                name: 'ProcessRework',
                component: VisualizationSubview,
                props: { forcedTab: 'LOOPS', hideTabs: true },
                meta: { footer: true, contextDrawer: true },
            },
            {
                path: 'conformance',
                name: 'ProcessConformance',
                component: ConformanceSubview,
                meta: { footer: true, contextDrawer: true },
            },
            {
                path: 'traces',
                name: 'ProcessTraces',
                component: TracesSubview,
                meta: { footer: true, contextDrawer: true },
            },
            {
                path: 'dashboards',
                name: 'ProcessDashboards',
                component: DashboardsSubview,
                meta: { footer: true, contextDrawer: true },
            },
            {
                path: 'tools',
                name: 'ProcessTools',
                redirect: { name: 'ProcessAttributes' },
            },
            {
                path: 'tools/attributes',
                name: 'ProcessAttributes',
                component: AnalysisToolsSubview,
                props: { forcedTab: 'ATTRS', hideTabs: true },
                meta: { footer: true, contextDrawer: true },
            },
            {
                path: 'tools/metrics',
                name: 'ProcessMetrics',
                component: AnalysisToolsSubview,
                props: { forcedTab: 'DASHBOARD', hideTabs: true },
                meta: { footer: true, contextDrawer: true },
            },
            {
                path: 'tools/comparisons',
                name: 'ProcessComparisons',
                component: AnalysisToolsSubview,
                props: { forcedTab: 'COMPARISON', hideTabs: true },
                meta: { footer: true, contextDrawer: true },
            },

            // Booster (canonical)
            {
                path: 'booster',
                name: 'ProcessBooster',
                redirect: { name: 'ProcessOverview' },
            },
            {
                path: 'booster/overview',
                name: 'ProcessOverview',
                component: BoosterSubview,
                props: { forcedTab: 'OVERVIEW' },
                meta: { contextDrawer: true },
            },
            {
                path: 'booster/alerts',
                name: 'ProcessAlerts',
                component: BoosterSubview,
                props: { forcedTab: 'ALERTS' },
                meta: { contextDrawer: true },
            },
            {
                path: 'booster/prediction',
                name: 'ProcessPrediction',
                component: BoosterSubview,
                props: { forcedTab: 'PREDICTION' },
                meta: { contextDrawer: true },
            },
            {
                path: 'booster/simulation',
                name: 'ProcessSimulation',
                component: BoosterSubview,
                props: { forcedTab: 'IMPROVEMENT' },
                meta: { contextDrawer: true },
            },
            {
                path: 'settings',
                name: 'ProcessSettings',
                component: SettingsSubview,
                meta: { contextDrawer: true },
            },
        ],
    },
]
